import { useState, useCallback } from 'react';
import { handleAPIError } from '../utils/errors';
import { useToast } from '../context';

export const useAPI = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { showError, showSuccess } = useToast();

    const execute = useCallback(async (apiCall, showErrorToast = true, showSuccessToast = false) => {
        setLoading(true);
        setError(null);

        try {
            const result = await apiCall();
            if (showSuccessToast) {
                showSuccess(result.message);
            }
            return result;
        } catch (err) {
            const errorInfo = handleAPIError(err);
            setError(errorInfo);

            // Show toast notification for errors
            if (showErrorToast) {
                showError(errorInfo.message);
            }

            throw errorInfo;
        } finally {
            setLoading(false);
        }
    }, [showError, showSuccess]);

    const clearError = useCallback(() => {
        setError(null);
    }, []);

    return {
        loading,
        error,
        execute,
        clearError,
    };
};

export default useAPI;
